import { RootState } from '../../RootState';
import selectRequiredSettings from './selectRequiredSettings';

const selectPricesIncludeTax = (state: RootState): boolean => {
  const settings = selectRequiredSettings(state);
  return settings.pricesIncludeTax;
};

export default selectPricesIncludeTax;
